import { forwardRef } from "react";

import { cx, styled } from "simplydo/react/styled";

import { alignItems, gapCss, gridTemplate, textAlignCss } from "./Grid.styles";
import type { GridRowProps } from "./Grid.types";
import { GridColumn } from "./GridColumn";

export const StyledGridRow = styled.div<{
  $columns: number;
  $centered?: boolean;
  $verticalAlign?: string;
  $textAlign?: string;
  $gap?: string | number;
}>`
  display: grid;
  grid-column: 1 / -1;
  grid-template-columns: ${({ $columns }) => gridTemplate($columns)};
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  gap: ${({ $gap }) => gapCss($gap)};
  justify-items: ${({ $centered }) => ($centered ? "center" : "stretch")};
  align-items: ${({ $verticalAlign }) => alignItems($verticalAlign)};
  text-align: ${({ $textAlign }) => textAlignCss($textAlign)};

  .is-centered > ${GridColumn} {
    width: 100%;
    max-width: 100%;
    justify-self: stretch;
  }
`;

const GridRowComponent = forwardRef<HTMLDivElement, GridRowProps>(
  (props, ref) => {
    const {
      columns = 1,
      centered,
      verticalAlign,
      textAlign,
      gap,
      children,
      className,
      style,
      ...rest
    } = props;
    return (
      <StyledGridRow
        ref={ref}
        className={cx(centered && "is-centered", className)}
        style={style}
        $columns={columns}
        $centered={centered}
        $verticalAlign={verticalAlign}
        $textAlign={textAlign}
        $gap={gap}
        {...rest}
      >
        {children}
      </StyledGridRow>
    );
  },
);

GridRowComponent.displayName = "GridRow";

export const GridRow = styled(GridRowComponent)``;
